import { map, includes } from "lodash"

const ADV = 10000000

function createSecuritySearchFilters(missingDataFiles) {
  const etfFilter = {
    assetClass: { eq: "equity" },
    assetSubclass: { eq: "etf" },
  }

  if (!includes(missingDataFiles, "securityLiquidity")) {
    etfFilter.averageDailyVolume = { gte: ADV }
  }

  return {
    ETF: etfFilter,
    INDEX: { assetClass: { eq: "index" } },
  }
}

function getFactorFilter(factorId, direction) {
  if (direction === "positive") {
    return { id: factorId, gt: 0 }
  } else {
    return { id: factorId, lt: 0 }
  }
}

export function getSecuritiesFinderFilterAndSort(factorId, direction, missingDataFiles) {
  const filter = {
    assetSubclass: { eq: "etf" },
    factorExposure: [getFactorFilter(factorId, direction)],
  }

  if (!includes(missingDataFiles, "securityLiquidity")) {
    filter.averageDailyVolume = { gte: ADV }
  }

  return {
    filter,
    sort: {
      direction: direction === "negative" ? "ASC" : "DESC",
      type: "exposure",
      id: factorId,
    },
  }
}

export function getQueryFilterAndSort(factorId, direction, missingDataFiles) {
  const filters = createSecuritySearchFilters(missingDataFiles)
  return {
    filter: map(filters, filter => ({ ...filter, factorExposure: [getFactorFilter(factorId, direction)] })),
    sort: {
      factorExposureId: factorId,
      direction: direction === "positive" ? "DESC" : "ASC",
    },
  }
}
